import { render, staticRenderFns } from "./ModalSelecaoTipoAlerta.vue?vue&type=template&id=adb351f6&lang=pug"
import script from "./ModalSelecaoTipoAlerta.vue?vue&type=script&lang=js"
export * from "./ModalSelecaoTipoAlerta.vue?vue&type=script&lang=js"
import style0 from "./ModalSelecaoTipoAlerta.vue?vue&type=style&index=0&id=adb351f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports